export const DEFAULT_POST_CONTENT = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];
